import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { spacing } from '../../../theme-v2';

const { Title, Text } = Typography;

export type LtiSessionExpiredProps = {
  /** Optional full-page background image URL (apps own their assets). */
  backgroundImage?: string;
};

export const LtiSessionExpired = ({
  backgroundImage,
}: LtiSessionExpiredProps) => {
  const { t } = useTranslation();

  return (
    <StyledCanvas $image={backgroundImage} justify="center" align="center">
      <Flex
        vertical
        align="center"
        justify="center"
        gap={spacing.sm}
        style={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          maxWidth: 'min(90vw, 480px)',
        }}
      >
        <Title level={2} style={{ margin: 0 }}>
          {t('ltiSessionExpiredPage.title')}
        </Title>
        <Text type="secondary" style={{ fontSize: 16 }}>
          {t('ltiSessionExpiredPage.description')}
        </Text>
      </Flex>
    </StyledCanvas>
  );
};

// ─── Styled components ───

const StyledCanvas = styled(Flex)<{ $image?: string }>`
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: ${spacing.base}px;
  background-image: ${({ $image }) => ($image ? `url(${$image})` : 'none')};
  background-size: cover;
  background-position: top left;
`;
